module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false || _vm.attribute.groupId === 1) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请填写",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.valueText
    }
  }) : (_vm.attribute.sorteditAble === true && (_vm.attribute.columnName === 'TvNoName' || _vm.attribute.columnName === 'TvNoNumber')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "选填",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "click": function($event) {
        return _vm.control(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "必填",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "click": function($event) {
        return _vm.control(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10bd0dc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finder/FinderBox/FinderAttrTextAreaBox.vue
// module id = 1539
// module chunks = 8